/**
 * Точка входа SPA. Роутера нет намеренно: приложение — одна страница с двумя
 * состояниями (идёт проверка / готов отчёт), а ссылка на сохранённый отчёт
 * передаётся параметром `?token=` и разбирается в App.vue.
 */

import { createApp } from 'vue';
import App from './App.vue';
import './styles.css';

createApp(App).mount('#app');
